const cases = [
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    title: 'サービス紹介ページ',
    description: 'サービスの特長や料金、導入の流れなどを1ページにまとめて、問い合わせにつなげます。',
    examples: ['コンサルティング', 'Web制作', '清掃サービス'],
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    title: '店舗・サロン紹介ページ',
    description: 'アクセスやメニュー、雰囲気を伝えて、来店予約や問い合わせにつなげます。',
    examples: ['美容室', 'エステサロン', '飲食店'],
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: '採用ページ',
    description: '仕事内容や職場の魅力を伝えて、応募フォームへスムーズにつなげます。',
    examples: ['正社員採用', 'アルバイト募集', 'インターン'],
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    title: 'キャンペーンページ',
    description: '期間限定の特典やイベント情報を掲載して、申込みや参加を促します。',
    examples: ['セール告知', 'オープン記念', 'セミナー集客'],
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
    title: '会社案内ページ',
    description: '事業内容や代表メッセージ、実績などをまとめて、信頼感を伝えます。',
    examples: ['会社概要', '事業紹介', '代表挨拶'],
  },
];

export default function UseCases() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-surface">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="section-label">用途</span>
          <h2 className="section-title">こんなページに使えます</h2>
          <p className="section-subtitle max-w-lg mx-auto">
            業種や目的に合わせて、さまざまなページを作成できます。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cases.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-lg p-6 border border-border hover:shadow-md transition-all duration-200"
            >
              <div className="w-10 h-10 rounded-md bg-surface flex items-center justify-center text-primary mb-4">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-primary mb-2">{item.title}</h3>
              <p className="text-sm text-textMuted leading-relaxed mb-4">{item.description}</p>
              <div className="flex flex-wrap gap-2">
                {item.examples.map((ex) => (
                  <span
                    key={ex}
                    className="text-xs text-textMuted bg-surface px-2.5 py-1 rounded-full"
                  >
                    {ex}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
